import { computed } from 'vue';
import { useStore } from 'vuex';
import {
  FundingInquiryType,
  RollingFundingInquiry,
} from '@/types/funding-inquiry.types';

export function useRollingFundingInquiries() {
  const store = useStore();

  const businessId = computed(() => store.getters.businessId);

  const latestValidRollingFundingInquiry =
    computed<RollingFundingInquiry | null>(() => {
      const validInquiries = store.getters.fundingInquiries?.filter(
        (inquiry: any) => new Date(inquiry.validUntil) >= new Date(),
      );
      return validInquiries?.[0] || null;
    });

  const fetchLatestRollingFundingInquiry = async () => {
    if (!businessId.value) {
      console.warn('Business ID not available for fetching funding inquiries');
      return null;
    }

    // Skip fetch if data already exists in store
    if (latestValidRollingFundingInquiry.value) {
      return latestValidRollingFundingInquiry.value;
    }

    await store.dispatchApiAction('GET_FUNDING_INQUIRIES', {
      businessId: businessId.value,
      type: FundingInquiryType.ROLLING_FUNDING,
      latest: true,
    });

    return latestValidRollingFundingInquiry.value;
  };

  return {
    fetchLatestRollingFundingInquiry,
    latestValidRollingFundingInquiry,
  };
}
